import { validate } from './locale-validations';

export * from './analytics';
export * from './common';
export * from './excel-service';
export * from './locale';
export * from './path';
export * from './url-parser';
export * from './events';
export * from './types';
export * from './utils';
export * from './lookups';
export * from './helpers';
export * from './axios';
export * from './fetchers/index';
export * from './navigation';
export * from './breadcrumbs';
export * from './indexDB';
export * from './store';
export * from './services';
export * from './locale-validations';
export * from './formatters';
export * from './colors';
export * from './price';
export * from './parsers';
export * from './number';

// Global visibility
window.pes = window.pes || {};
window.pes.validateCountryLanguage = validate;
